angular.module('angus.controllers').directive('firmwareUpdate', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/firmwareUpdate/firmwareUpdateView.html' 
    };
});
  